<template>
  <p>{{ textColor }}</p>
</template>

<script>
export default {
  name: 'CellRendererOrigin',
  computed: {
    textColor () {
      return this.params.value ? 'Sem alertas' : 'Lote criado fora da área'
    }
  }
}
</script>
